//region Modals
import {showModal, closeModals} from "./modal";
// вызов модалок по клику на элементы с классом modal-link
[...document.querySelectorAll('.modal-link')].map(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    showModal(e.target); // or showModal('#modal') or showModal('.modal') or
                         // showModal(document.querySelector('#modal'))
  })
});
// вызов модалок по клику на элементы с классом country-code-input
[...document.querySelectorAll('.country-code-input')].map(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    // установка источника открытия модалки, чтобы при выборе кода страны либо
    // открывать модалку регистрации (если окно открыто из нее), либо не
    // открывать модалок (если открыто из sms приглашения)
    const source = link.getAttribute('data-source');
    showModal('#modal_country-code', () => {
      document.querySelector('#modal_country-code').setAttribute('data-source', source);
    })
  })
});
//endregion

//region Выбор кода страны
const countries = document.querySelectorAll('.countries li');
const countriesModal = document.querySelector('#modal_country-code');
if (countries) {
  const countryCodeInputs = document.querySelectorAll('.country-code-input');
  [...countries].map((country) => {
    // при клике на страну в модалке
    country.addEventListener('click', (e) => {
      e.preventDefault();
      // передать в инпуты выбранный код страны
      [...countryCodeInputs].map((el) => {
        el.value = country.getAttribute('data-code');
        // установим для инпута readonly, чтобы нельзя было изменить код страны
        // вручную
        el.setAttribute('readonly', 'true');
      });
      // если модалка выбора кода страны открыта из модалки регистрации -
      // открываем модалку регистрации,
      if (countriesModal.getAttribute('data-source') === 'modal') {
        showModal('#modal_registration');
      }
      // иначе - просто закрываем выбор кода страны
      else {
        closeModals();
      }
    })
  });
  const enterCodeManually = document.querySelector('.enter-code-manually');
  if (enterCodeManually) {
    // при клике на "Ввести код вручную"
    enterCodeManually.addEventListener('click', (e) => {
      e.preventDefault();
      // разблокируем все поля ввода кода страны
      [...countryCodeInputs].map((el) => {
        el.removeAttribute('readonly');
      });
      // если модалка выбора кода страны открыта из модалки регистрации -
      // открываем модалку регистрации,
      if (countriesModal.getAttribute('data-source') === 'modal') {
        showModal('#modal_registration');
      }
      // иначе - просто закрываем выбор кода страны
      else {
        closeModals();
      }
    })
  }
}
//endregion

//region Модалка с подтверждением номера телефона
const modalPwRestoreTel = document.querySelector('.form_pw-restore-tel');
if (modalPwRestoreTel) {
  modalPwRestoreTel.addEventListener('submit', (e) => {
    e.preventDefault();
    if (modalPwRestoreTel.querySelector('input[type="tel"]').value.length === 18) {
      const error = modalPwRestoreTel.querySelector('.font_red');
      if (error) {
        error.parentElement.removeChild(error);
      }
      const tel = modalPwRestoreTel.querySelector('input[type="tel"]').value;
      const modalPhoneConfirmation = document.querySelector('#modal_phone-confirmation');
      modalPhoneConfirmation.querySelector('input[type="tel"]').value = tel;
      showModal(modalPhoneConfirmation);


      const button = document.querySelector('.form__btn-timer');
      const timer = () => {
        button.setAttribute('disabled', 'true');
        let currentTime = Number(button.getAttribute('data-time'));
        const interval = setInterval(() => {
          if (currentTime === 0) {
            button.innerHTML = 'Прислать еще раз';
            button.removeAttribute('disabled');
            return clearInterval(interval);
          }
          button.innerHTML = `Прислать еще раз (${currentTime})`;
          currentTime--;
        }, 1000);
      };

      button.addEventListener('click', (e) => {
        e.preventDefault();
        timer();
      });
      timer();
    }
    else {
      const errorMsg = modalPwRestoreTel.querySelector('.font_red');
      if (errorMsg) {
        return false;
      }

      const error = document.createElement('div');
      error.classList.add('font_red');
      error.innerHTML = 'Телефон введен неверно';
      error.style.marginTop = "7px";
      modalPwRestoreTel.querySelector('input[type="tel"]').parentElement.appendChild(error);
    }
  })
}
// ! Открытие модалки с подтверждением номера телефона
//endregion

//region Маска кода подтверждения
window.addEventListener('load', (e) => {
  const confirmation = document.querySelector('.form_phone-confirmation input[type="text"]');
  if (confirmation) {
    IMask(confirmation, {
      mask: '0000',
      overwrite: true,
    });
  }
});
//endregion

//region Маска телефона
window.addEventListener('load', () => {
  const maskedPhonesInput = document.querySelectorAll('input[type="tel"]');
  if (maskedPhonesInput) {
    const maskOptions = {
      mask: '+{7} (000) 000-00-00',
    };
    [...maskedPhonesInput].map((el) => {
      const maskedInput = IMask(el, maskOptions);
      el.addEventListener('keydown', () => {
        if (maskedInput.unmaskedValue === '78') {
          maskedInput.value = '+7 (';
        }
      });
      // simple validation
      el.addEventListener('blur', () => {
        if (maskedInput.unmaskedValue.length === 11) {
          maskedInput.el.input.classList.add('input_valid')
        }
        else {
          maskedInput.el.input.classList.add('input_invalid')
        }
      })
    });
  }
});
//endregion

//region Селект выбора языка
window.addEventListener('load', () => {
  customSelect('.lang-select select');
  const langSelect = document.querySelectorAll('.lang-select select');
  [...langSelect].map(select => {
    const customSelectOpener = select.previousElementSibling;
    customSelectOpener.setAttribute('data-value', select.value);
    select.addEventListener('change', (e) => {
      customSelectOpener.setAttribute('data-value', e.target.value);
    })
  })
});
//endregion

//region Полифилл для object-fit
window.addEventListener('load', () => {
  objectFitImages();
});
//endregion

//region Табы
function Tabs() {
  var bindAll = function () {
    var menuElements = document.querySelectorAll('[data-tab]');
    for (var i = 0; i < menuElements.length; i++) {
      menuElements[i].addEventListener('click', change, false);
    }
  };

  var clear = function () {
    var menuElements = document.querySelectorAll('[data-tab]');
    for (var i = 0; i < menuElements.length; i++) {
      menuElements[i].classList.remove('js-active');
      var id = menuElements[i].getAttribute('data-tab');
      document.getElementById(id).classList.remove('js-active');
    }
  };

  var change = function (e) {
    clear();
    e.target.classList.add('js-active');
    var id = e.currentTarget.getAttribute('data-tab');
    document.getElementById(id).classList.add('js-active');
  };

  bindAll();
}
var connectTabs = new Tabs();
//endregion

//region Параметры из url
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

// Редирект на страницу /app
if (getUrlParameter('group')) {
  document.location.href = '/app'
}
//endregion